var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'BaseColumn',
    {
      'BaseColumn--1/1': _vm.cols === 1,
      'BaseColumn--1/2': _vm.cols === 2,
      'BaseColumn--1/3': _vm.cols === 3,
      'BaseColumn--1/4': _vm.cols === 4
    }
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }